import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import React, { FunctionComponent } from 'react';

import styles from './FocalPointImage.module.scss';

export interface FocalPointImageProps {
    className?: string;
    focalPoint?: {
        x: number;
        y: number;
    };
    title: string;
    src: string;
}

export const FocalPointImage: FunctionComponent<FocalPointImageProps> = ({
    className,
    focalPoint,
    title,
    src,
}) => {
    const { focalPointClassName, styleTag } = !isEmpty(focalPoint)
        ? {
              focalPointClassName: styles.focalPoint,
              styleTag: `:root {
                    --focus-x: ${focalPoint ? focalPoint.x * 100 : 0}%;
                    --focus-y: ${focalPoint ? focalPoint.y * 100 : 0}%;
                `,
          }
        : {
              focalPointClassName: undefined,
              styleTag: undefined,
          };

    return (
        <>
            <style>{styleTag}</style>
            <div
                className={classNames(
                    styles.container,
                    'eds-show-up-mn',
                    className,
                )}
            >
                <img
                    className={classNames(
                        styles.image,
                        'eds-max-img',
                        focalPointClassName,
                    )}
                    alt={title}
                    src={src}
                    data-testid="focal-point-image"
                />
                <div className={styles.ie11FlexFix} />
            </div>
        </>
    );
};
